import React from 'react';
import { Skeleton } from '@mui/material';
import { styled } from "@mui/material/styles";

import CenteredContainer from '@/common/CenteredContainer';

const SkeletonLoader = styled(Skeleton)({
    marginTop: '25px'
});

export const Loaders = () => (
        <CenteredContainer>
            {
                Array.from({ length: 3 }, (_, k) => (
                    <SkeletonLoader
                        key={k}
                        variant="rectangular"
                        width="100%"
                        height={200}
                    />
                ))
            }
        </CenteredContainer>
    );

export default Loaders;